import React from 'react';
const WhatsappColoredSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='14'
      viewBox='0 0 15 14'
      fill='none'
      className={className}
      {...props}
    >
      <path
        d='M12.9888 3.23742C10.8888 -0.000107021 6.60124 -0.962614 3.27621 1.0499C0.0386867 3.06242 -1.01132 7.43745 1.08869 10.675L1.2637 10.9375L0.563691 13.5625L3.18871 12.8625L3.45121 13.0375C4.58872 13.65 5.81373 14 7.03874 14C8.35125 14 9.66376 13.65 10.8013 12.95C14.0388 10.85 15.0013 6.56244 12.9888 3.23742ZM11.1513 9.97497C10.8013 10.5 10.3638 10.85 9.75126 10.9375C9.40126 10.9375 8.96375 11.1125 7.21374 10.4125C5.72623 9.71247 4.50122 8.57496 3.62621 7.26245C3.10121 6.64994 2.83871 5.86244 2.75121 5.07493C2.75121 4.37493 3.01371 3.76242 3.45121 3.32492C3.62621 3.14992 3.80122 3.06242 3.97622 3.06242H4.41372C4.58872 3.06242 4.76372 3.06242 4.85122 3.41242C5.02623 3.84992 5.46373 4.89993 5.46373 4.98743C5.55123 5.07493 5.55123 5.24993 5.46373 5.33743C5.55123 5.51244 5.46373 5.68744 5.37623 5.77494C5.28873 5.86244 5.20123 6.03744 5.11373 6.12494C4.93872 6.21244 4.85122 6.38744 4.93872 6.56244C5.28873 7.08745 5.72623 7.61245 6.16373 8.04995C6.68874 8.48746 7.21374 8.83746 7.82625 9.09996C8.00125 9.18746 8.17625 9.18746 8.26375 9.01246C8.35125 8.83746 8.78875 8.39996 8.96375 8.22496C9.13876 8.04995 9.22626 8.04995 9.40126 8.13745L10.8013 8.83746C10.9763 8.92496 11.1513 9.01246 11.2388 9.09996C11.3263 9.36246 11.3263 9.71247 11.1513 9.97497Z'
        fill='#18CA26'
      />
    </svg>
  );
};

export default WhatsappColoredSVG;
